import { Injectable } from '@angular/core';
import FingerprintJS, { Agent, GetResult } from '@fingerprintjs/fingerprintjs';

@Injectable({
  providedIn: 'root',
})
export class VisitorService {

  private readonly fpPromise:Promise<Agent>;

  constructor() {
    this.fpPromise = FingerprintJS.load();
  }

  public async visitorId(): Promise<string> {
    const fpPromise = await this.fpPromise;
    const result: GetResult = await fpPromise.get();
    return result.visitorId;
  }
}
